import { UPDATE_CURRENT_RENDERED_TREE, SET_MINIMIZE_WINDOW } from './actionTypes'

export function updateCurrentTree(newTree, stateLocation)
{
    return {
        type : UPDATE_CURRENT_RENDERED_TREE,
        payload : {
            newTree,
            stateLocation
        }
    }
}


export function setMinimize(isMinimized, stateLocation)
{
    return {
        type: SET_MINIMIZE_WINDOW,
        payload: {
            value: isMinimized,
            stateLocation,
        },
    };
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window/src/actions/actions.ts